import { Expose, Type } from "class-transformer";
import type { UUID } from "crypto";
import { DisabilityDto } from "../../../../../legacy/services/persona/dtos/disability/disability.dto";
import type { IDisabilityDto } from "../../../../../legacy/services/persona/dtos/disability/disability.dto.interface";
import { ProfileDataDto } from "../../../../../legacy/services/profile-data/dtos/profile-data.dto";
import type { IProfileDataDto } from "../../../../../legacy/services/profile-data/dtos/profile-data.dto.interface";
import type { DisabilityLaw104SeverityEnum } from "../../../../../features/profile/constants/disability-law-104-severity.enum";
import type { GenderEnum } from "../../../../../types/persona/constants/gender.enum";
import type { TaxCodeModeEnum } from "../../../../../types/persona/constants/tax-code-mode.enum";
import type { IPersonaDto } from "./persona.dto.interface";

export class PersonaDto implements IPersonaDto {
  @Expose()
  id?: UUID;

  @Expose()
  citizenId: number | null = null;

  @Expose()
  firstName?: string;

  @Expose()
  lastName?: string;

  @Expose()
  taxCode?: string;

  @Expose()
  birthDate?: string;

  @Expose()
  birthPlace?: string;

  @Expose()
  gender?: GenderEnum;

  @Expose()
  citizenship?: string[];

  @Expose()
  residencePermitType?: string;

  @Expose()
  registeredCountry?: string;

  @Expose()
  registeredMunicipality?: string;

  @Expose()
  registeredProvince?: string;

  @Expose()
  registeredRegion?: string;

  @Expose()
  registeredCountryAsCurrent?: boolean;

  @Expose()
  isRegisteredInAire?: boolean;

  @Expose()
  currentCountry?: string;

  @Expose()
  currentMunicipality?: string;

  @Expose()
  currentAddressType?: string;

  @Expose()
  @Type(() => DisabilityDto)
  disabilities!: IDisabilityDto[];

  @Expose()
  @Type(() => ProfileDataDto)
  profileData?: IProfileDataDto;

  @Expose()
  disability?: boolean;

  @Expose()
  disabilityLaw104?: boolean;

  @Expose()
  disabilityLaw104Severity?: DisabilityLaw104SeverityEnum;

  @Expose()
  maritalStatus?: string;

  @Expose()
  taxCodeMode?: TaxCodeModeEnum | null;
}
